import styled from "styled-components"
import InputWithLabel from "shared/components/InputWithLabel"
import InputWithDuplicateCheck from "shared/components/InputWithDuplicateCheck";
import ReportPermission from "./ReportPermission";
import { hw } from "features/homework/homeworkUi";

interface RequiredInputsProps{
    branchInputs:{
        name:string,
        tel:string,
        address:string,
        address_detail:string,
        business_num:string,
        owner_name:string,
        owner_tel:string,
        id:string,
        pw:string,
        pw_re:string
    },
    reportPermission:{
        word:boolean,
        sentence:boolean,
        video:boolean
    }
    onPermissionChange:(event: React.ChangeEvent<HTMLInputElement>) => void,
    onBranchChange:(event: React.ChangeEvent<HTMLInputElement>) => void,
    setIsDuplicated:React.Dispatch<React.SetStateAction<any>>
}

const RequiredInputs = ({reportPermission, onPermissionChange, branchInputs, onBranchChange, setIsDuplicated}:RequiredInputsProps) => {
    return(
        <Container>
            <Title>필수 입력</Title>
            <Inputs>
                <InputWithLabel required={true} label="원장 성명" name="owner_name" value={branchInputs.owner_name} onChange={onBranchChange} placeholder="원장 성명을 입력해주세요"/>
                <InputWithLabel required={true} label="상호명" name="name" value={branchInputs.name} onChange={onBranchChange} placeholder="상호명을 입력해주세요"/>
                <InputWithDuplicateCheck setIsDuplicated={setIsDuplicated} required={true} label="아이디" name="id" value={branchInputs.id} onChange={onBranchChange} table="User/Auth/Log" field="id"/>
                <InputWithLabel required={true} type="password" label="비밀번호" name="pw" value={branchInputs.pw} onChange={onBranchChange} placeholder="영문, 숫자를 포함해 주세요"/>
                <InputWithLabel required={true} type="password" label="비밀번호 재입력" name="pw_re" value={branchInputs.pw_re} onChange={onBranchChange} placeholder="비밀번호를 다시 입력해주세요"/>
                <Hint>비밀번호에는 영문과 숫자가 반드시 들어가야 합니다.</Hint>
                <PermissionWrap>
                    <ReportPermission input={reportPermission} onChange={onPermissionChange}/>
                </PermissionWrap>
            </Inputs>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: ${hw.bg};
    padding: 20px 22px;
    border-radius: 14px;
    border: 1px solid ${hw.border};
`

const Title = styled.h2`
    margin: 0;
    color: ${hw.text};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.02em;
`

const Inputs = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px 20px;

    @media (max-width: 800px) {
        grid-template-columns: 1fr;
    }
`

const Hint = styled.p`
    margin: 0;
    grid-column: 1 / -1;
    font-size: 12px;
    color: ${hw.brand};
    font-weight: 500;
`

const PermissionWrap = styled.div`
    grid-column: 1 / -1;
`

export default RequiredInputs;
